import React, { useState, useEffect } from 'react';
import styles from "assets/scss/task_management.module.css";
import { useBaseModal, PayrollClient } from 'services';
import ReAssignTask from './ReAssignTask';
import AssignedTaskModal from '../User/AssignedTaskModal';
import { getOverdueTime, getTextColor } from "services/util";
import { Trans } from 'react-i18next';
import { NotificationManager } from "react-notifications";

function AssignedTaskCard({ task, onDelete, onClick, onUpdate, buckets, fetchEmployees, onReassign, fetchLabels, groups, userPermission, t }) {
    const [setModalOpen, toggle, MainModal] = useBaseModal();
    const [, toggleReassign, ReassignModal] = useBaseModal();
    const [showDeleteButton, setShowDeleteButton] = useState(false);

    const client = PayrollClient();

    const handleUpdate = () => {
        if (!showDeleteButton) {
            toggle();
        }
    };

    const handleReassignClick = (e) => {
        e.stopPropagation();
        toggleReassign();
    };

    const handleReassign = async (selectedEmployees, reason) => {
        await onReassign(task.id, selectedEmployees, reason);
        toggleReassign();
    };

    const overdueTime = getOverdueTime(task?.task?.end_date);
    const handleRadioClick = (e) => {
        e.stopPropagation();
    };
    const activeTab = "assignedTasks";
    const updateBucketTask = async (task) => {
        const task_obj = task?.task
        try {
            const payload = { ...task_obj,
                planner_bucket: task_obj?.planner_bucket?.id,
                task_label: task_obj?.task_label?.map(label => label?.id),
                attachment: {name: "skip"},
                progress: task?.progress,
             };
            if (activeTab === 'assignedTasks'){
                payload.assignedTasks = true;
                
            }
            await client.put(`/bucket-task-management/${task_obj?.id}/update_bucket_task`, payload);
            NotificationManager.success(t("Task Updated successfully"));
        } catch (err) {
            NotificationManager.error(t('Error while Updating the task'));
        }
    };

    const handleCheckboxChange = async (task, e) => {
        const newProgress = e.target.checked ? "Completed" : "Not Started";
        
        const updatedTask = {
            ...task,
            progress: newProgress,
        };

        await updateBucketTask(updatedTask, activeTab);
    };

    const defaultOptions = task?.task?.task_label?.map(id => {
        return { value: id?.id, label: id?.label_name, color_code: id?.color_code || '', textColor: getTextColor(id?.color_code || '') };
    });

    return (
        <div className={styles.card} onClick={handleUpdate}>
            <div className={styles.header}>
            <div className="d-flex flex-wrap">
                {defaultOptions?.map((i) => (
                    <span 
                        key={i?.value} 
                        style={{
                            borderRadius: '10%', 
                            backgroundColor: i?.color_code || '',
                            marginRight: "3px",
                            color: i?.textColor || '',
                        }} 
                        className='p-1 mt-1'>
                        {i?.label}
                    </span>
                ))}
            </div>
            </div>
            <div className={styles.content}>
            <div className={styles.radioTitle}>
                {task?.task?.allow_update && (
                    <input
                        type="checkbox"
                        name="taskCheckbox"
                        onChange={(e) => handleCheckboxChange(task, e)}
                        checked={task?.task?.progress === "Completed"}
                        onClick={handleRadioClick}
                    />
                )}
                
                {task?.task?.progress === "Completed" ? (
                    <span className={`text-decoration-line ${styles.taskTitle} ${styles.inputField}`}>
                        {task?.task?.bucket_task_name ? task?.task?.bucket_task_name : ""}
                    </span>
                ) : (
                    <span className={styles.taskTitle}>
                        {task?.task?.bucket_task_name ? task?.task?.bucket_task_name : ""}
                    </span>
                )}
            </div>
            </div>
            <div className={styles.line}></div>
            <div className={styles.bottom_line}>
                <div className={styles.dueDate}>
                    <button className={task?.task?.end_date ? (new Date(task?.task?.end_date) < new Date() ? styles.duePassed : styles.dueUpcoming) : styles.noDueDate}>
                        {task?.task?.end_date ? new Date(task?.task?.end_date).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' }) : "Due"}
                    </button>
                    {overdueTime && (
                        <span className={`${task?.task?.end_date ? (new Date(task?.task?.end_date) < new Date() ? styles.duePassed : styles.dueUpcoming) : styles.noDueDate} ml-2`}>{overdueTime}</span>
                    )}
                </div>
                {task?.task?.allow_update && (
                    <div className={styles.assign_button_div}>
                        <button className={` p-1 rounded ${styles.assign_button}`} onClick={handleReassignClick}><Trans>Reassign</Trans></button>
                    </div>
                )}
            </div>
            <MainModal title="Update Task" action="Update">
                <AssignedTaskModal
                    task={task}
                    onUpdate={onUpdate}
                    onDelete={onDelete}
                    onClick={onClick}
                    onClose={toggle}
                    availableEmployees={fetchEmployees}
                    fetchLabels={fetchLabels}
                    groups={groups}
                    buckets={buckets}
                    userPermission={userPermission}
                    t={t}
                />
            </MainModal>
            <ReassignModal title="Reassign Task">
                <ReAssignTask
                    task={task}
                    onClose={toggleReassign}
                    availableEmployees={userPermission ? fetchEmployees : undefined}
                    onReassign={handleReassign}
                    userPermission={userPermission}
                />
            </ReassignModal>
        </div>
    );
}

export default AssignedTaskCard;
